import React, { useContext, useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import _ from "lodash";
import "../../../styles/home.scss";
import "../../../styles/slick.css";
import previousImg from "../../../assets/home/previous.png";
import nextImg from "../../../assets/home/next.png";

import useWorks from "../../../hooks/useWorks";
import useUsers from "../../../hooks/useUsers";
import Panorama from "../../common/Panorama";
import AppContext from "../../../AppContext";
// import ContentLoader from "react-content-loader";
import useScreenSize from "../../../hooks/useScreenSize";
import ProjectDescription from "../../common/ProjectDescription";

import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay, Pagination } from "swiper/modules";

// Import Swiper styles
import "swiper/css";
import "swiper/css/navigation";

import "../../../styles/landingPage/banner.scss";
import { useLocation } from "react-router-dom";
import Share from "../../ProjectView/Share";

const Banner = () => {
  const { screenSize } = useScreenSize();
  const { queryWorks } = useWorks();
  const { queryUsers, queryCompanies } = useUsers();
  const [works, setWorks] = useState([]);
  const { viewProject } = useContext(AppContext);
  const location = useLocation();
  const [_, setInit] = useState();
  const [isToggleShare, setIsToggleShare] = useState(false);

  const prevRef = useRef(null);
  const nextRef = useRef(null);

  useEffect(() => {
    init();
  }, []);

  const init = async () => {
    try {
      const { data: _workResults } = await queryWorks(
        {
          type: 1,
          active: true,
          deleted: false,
        },
        1,
        6,
        {
          name: 1,
          desc: 1,
          banner: 1,
          panorama: 1,
          createdBy: 1,
          createdOn: 1,
          company: 1,
          views: 1,
          type: 1,
          program: 1,
          renderer: 1,
          score: 1,
        },
        {
          createdOn: -1,
        }
      );

      const { data: _users } = await queryUsers(
        {
          _id: {
            $in: _workResults.map((w) => w.createdBy),
          },
        },
        1,
        _workResults.length
      );

      const { data: _companies } = await queryCompanies(
        {
          _id: {
            $in: _workResults.map((w) => w.company).filter((c) => !!c),
          },
        },
        1,
        _workResults.length,
        {
          logo: 1,
          name: 1,
        }
      );

      const _works = _workResults.map((w) => {
        const userFound = _users.find((u) => u._id === w.createdBy);
        if (userFound) w.user = userFound;

        if (w.company) {
          w.company = _companies.find((c) => c._id === w.company);
        }

        return w;
      });

      setWorks(
        _works.map((work, index) => {
          work.rating = work.score ?? 0;
          return work;
        })
      );
    } catch (error) {
      console.log("error", error);
    }
  };

  const handleShareClick = (workId) => {
    setIsToggleShare(workId);
  };

  const getDesc = (work) => {
    const {
      user: { _id, avatar, plan, firstname, surname },
      company,
      name,
      program,
      renderer,
      rating,
    } = work;

    // TODO: Rating score is hardcoded
    return (
      <ProjectDescription
        userId={_id}
        avatar={avatar}
        ownerName={`${firstname} ${surname ?? ""}`}
        company={company}
        workName={name}
        plan={plan}
        rating={rating ?? 0}
        program={program}
        renderer={renderer}
      />
    );
  };

  return (
    <>
      <div className="home-banner">
        <Swiper
          modules={[Autoplay, Navigation, Pagination]}
          spaceBetween={0}
          slidesPerView={1}
          autoplay={{
            delay: 5000,
            pauseOnMouseEnter: true,
          }}
          navigation={{
            prevEl: ".home-banner-previous-button",
            nextEl: ".home-banner-next-button",
          }}
          speed={600}
          onInit={() => setInit(true)}
          loop={true}
          pagination={false}
        >
          {works.map((work, index) => {
            return (
              <SwiperSlide key={index} className="swiper-no-swiping">
                <div className="home-banner-panorama" key={index}>
                  <Panorama
                    index={index}
                    workId={work._id}
                    panoramas={work.panorama.images}
                    isPreview={true}
                    onViewWork={() => {
                      viewProject(work._id, location);
                    }}
                    draggable={["lg", "xl"].includes(screenSize)}
                    height={"100%"}
                    work={work}
                    onShare={() => handleShareClick(work._id)}
                  />
                  <div className="home-banner-panorama__footer">
                    {getDesc(work)}
                  </div>
                </div>
              </SwiperSlide>
            );
          })}
        </Swiper>
        <img
          role="button"
          ref={prevRef}
          src={previousImg}
          className="home-banner-previous-button"
          width={50}
          height={50}
        />
        <img
          role="button"
          ref={nextRef}
          src={nextImg}
          className="home-banner-next-button"
          width={50}
          height={50}
        />
      </div>
      {isToggleShare && (
        <Share
          link={`https://urbaan.app/projects/${isToggleShare}`}
          onClose={() => {
            setIsToggleShare(undefined);
          }}
        />
      )}
    </>
  );
};

Banner.propTypes = {
  onSelect: PropTypes.func,
  onClick: PropTypes.func,
  isMenuShopping: PropTypes.bool,
  centerInsufficientSlides: PropTypes.bool,
  pagination: PropTypes.bool,
  useCustomPagination: PropTypes.bool,
  paginationRef: PropTypes.object,
};

Banner.defaultProps = {
  onSelect: () => {},
  onClick: () => {},
  isMenuShopping: false,
  centerInsufficientSlides: false,
  pagination: false,
  useCustomPagination: false,
  paginationRef: {},
};

export default Banner;
